import { Component, Inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ListagemExaminador } from 'src/app/models/listagem-examinador'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { UnespCoreMessageService } from 'src/libs/unesp-core'

@Component({
  selector: 'inscricoes-substituir-suplente-dialog',
  templateUrl: './substituir-suplente-dialog.component.html',
  styleUrls: ['./substituir-suplente-dialog.component.scss'],
})
export class SubstituirSuplenteDialogComponent {
  form: FormGroup

  constructor(
    public dialogRef: MatDialogRef<SubstituirSuplenteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comissaoJulgadoraId: number; suplentes: ListagemExaminador[] },
    private fb: FormBuilder,
    private comissaoJulgadoraService: ComissaoJulgadoraService,
    private unespCoreMessageService: UnespCoreMessageService
  ) {
    this.form = this.fb.group({
      suplenteId: [null, Validators.required],
      justificativa: ['', Validators.required],
    })
  }

  cancelar(): void {
    this.dialogRef.close()
  }

  confirmar(): void {
    if (this.form.valid) {
      this.comissaoJulgadoraService
        .subistituirSuplente(this.data.comissaoJulgadoraId, this.form.value.suplenteId, this.form.value.justificativa)
        .subscribe({
          next: () => {
            this.dialogRef.close(true)
            this.unespCoreMessageService.showMessageSuccess('Examinador Titular substituído com sucesso!')
          },
          error: err => {
            console.error('Erro ao substituir suplente:', err)
            this.unespCoreMessageService.showMessageError(
              'Erro ao substituir suplente: ' + err.error?.message || 'Erro desconhecido'
            )
          },
        })
    }
  }
}
